import {
  Form,
  Input,
  Row,
  Select_,
  TextArea,
  Col,
  Button,
  Spin,
  SuccessNotification,
  Space,
  Radio,
  DatePicker,
} from "components/common";
import React, { useState } from "react";
import { useEffect } from "react";
import { callGetApi, callGetApiWithAuth, callPostApi, callPostApiWithAuth } from "utils/api";
import { Wrapper } from "./NotifyPage.styled";
import { getUserPermissions } from "utils/text";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";

const NotifyPage = () => {
  const dispatch = useDispatch();
  const [userData, setUserData] = useState([]);
  const [rolesData, setRolesData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isTask, setIsTask] = useState(false);
  const [sentToWhom, setSentToWhom] = useState([]);

  const [sendToType, setsendToType] = useState("all");
  const [form] = Form.useForm();

  const options = [
    {
      name: "System",
      id: "System",
    },
    {
      name: "Myself",
      id: "MySelf",
    },
  ];
  const updates = [
    {
      name: "Message",
      id: "Message",
    },
    {
      name: "Task",
      id: "Task",
    },
    {
      name: "Notification",
      id: "Notification",
    },
  ];
  const Frequency = [
    {
      name: "Daily",
      id: "daily",
    },
    {
      name: "Weekly",
      id: "weekly",
    },
    {
      name: "Monthly",
      id: "monthly",
    },
  ];

  const onChange = (e) => {
    setsendToType(e.target.value);
  };

  const onFinish = (values) => {
    let payload = {
      message: values?.message,
      type: values?.type || "Notification",
      sendTo: sendToType || 'all',
      link: values?.link,
      recep: values?.recep,
      frequency: values?.frequency,
      sender: values?.sender,
      dismissed: values?.dismissed,
      isMessage: values?.isMessage,
      startDate: values?.startDate,
      endDate: values?.endDate,
    }
    callPostApiWithAuth('/notification', payload, (data) => {
      SuccessNotification(`${payload.type} sent successfully.`);
      notificationData();
      messageNotiGetApi();
      form.resetFields();
      form.setFieldValue("sender", " Myself");
      form.setFieldValue("recep", "All");
      form.setFieldValue("sendTo", "all");
      setsendToType('all')
      setIsTask(false);
    }, (err) => {
      console.log(err);
    })
  };

  const notificationData = () => {
    callGetApiWithAuth(
      "/notification/all/notifications",
      (data) => {
        dispatch({
          type: "SET_NOTIFICATION",
          payload: {
            notification: data,
          },
        });
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const messageNotiGetApi = () => {
    callGetApiWithAuth(
      "/notification/all/messages",
      (data) => {
        dispatch({
          type: "SET_MESSAGE",
          payload: {
            messages: data,
          },
        });
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const getUserAPi = () => {
    callGetApi("/user", (data) => {
      setIsLoading(false);
      setUserData([
        ...data.map((el) => {
          return {
            name: el?.username,
            id: el?._id,
          };
        }),
      ]);
    }, (err) => {
      setIsLoading(false);
      console.log(err);
    });
  };

  const getRoles = () => {
    callGetApi("/roles", (data) => {
      setIsLoading(false);
      setRolesData([
        ...data.map((el) => {
          return {
            name: el?.role,
            id: el?._id,
          };
        }),
      ]);
    }, (err) => {
      setIsLoading(false);
      console.log(err);
    });
  }

  useEffect(() => {
    setIsLoading(true);
    getUserAPi();
    getRoles();
  }, []);

  useEffect(() => {
    if (sendToType === "user") {
      setSentToWhom(userData)
    } else if (sendToType === "role") {
      setSentToWhom(rolesData)
    }
  }, [sendToType]);

  return (
    <Wrapper>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 20,
          }}
        >
          <Spin />
        </div>
      ) : (
        <div className="form-div">
          <Form
            name="basic"
            autoComplete="off"
            style={{ width: "100%" }}
            onFinish={onFinish}
            form={form}
          >
            <Row gutter={[15, 15]}>
              <Col span={24} className="message-col">
                <Row>
                  <Col lg={5} xs={24} className="label-col">
                    <label> Message:</label>
                  </Col>
                  <Col lg={19} xs={24} className="textarea-col">
                    {" "}
                    <Form.Item
                      name="message"
                      rules={[{ required: true, message: "Enter the message" }]}
                    >
                      <textarea className="textarea" type="text" />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row>
                  <Col lg={5} xs={24} className="label-col">
                    <label> Link:</label>
                  </Col>
                  <Col lg={19} xs={24}>
                    {" "}
                    <Form.Item
                      className="link"
                      name="link"
                    // rules={[{ required: true, message: "Enter the link" }]}
                    >
                      <Input
                        type="text"
                        placeholder="Enter the link"
                      // defaultValue="https://own-energy.web.app/"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row>
                  <Col lg={5} xs={24} className="label-col">
                    <label>Type:</label>
                  </Col>
                  <Col lg={19} xs={24}>
                    {" "}
                    <Form.Item
                      name="type"
                      className="sender-as"
                    // rules={[
                    //   { required: true, message: "Enter the Task-Updates" },
                    // ]}
                    >
                      <Select_
                        name
                        options={updates}
                        onChange={(e) => {
                          if (e == "Task") {
                            setIsTask(true);
                          } else {
                            setIsTask(false);
                          }
                        }}
                        defaultValue="Notification"
                      />
                    </Form.Item>{" "}
                  </Col>
                </Row>
              </Col>
              {isTask == true ? (
                <>
                  <Col span={24}>
                    <Row>
                      <Col lg={5} xs={24} className="label-col">
                        <label>Start Date:</label>
                      </Col>
                      <Col lg={19} xs={24}>
                        {" "}
                        <Form.Item
                          name="startDate"
                          className="sender-as"
                          rules={[
                            {
                              required: true,
                              message: "Select the Start Date",
                            },
                          ]}
                        >
                          <DatePicker picker="date" className="date-picker" />
                        </Form.Item>{" "}
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row>
                      <Col lg={5} xs={24} className="label-col">
                        <label>End Date:</label>
                      </Col>
                      <Col lg={19} xs={24}>
                        {" "}
                        <Form.Item name="endDate" className="sender-as">
                          <DatePicker picker="date" className="date-picker" />
                        </Form.Item>{" "}
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row>
                      <Col lg={5} xs={24} className="label-col">
                        <label>Frequency:</label>
                      </Col>
                      <Col lg={19} xs={24}>
                        {" "}
                        <Form.Item
                          name="frequency"
                          className="sender-as"
                          rules={[
                            { required: true, message: "Select Frequency" },
                          ]}
                        >
                          <Select_
                            name
                            options={Frequency}
                            defaultValue="Daily"
                          />
                        </Form.Item>{" "}
                      </Col>
                    </Row>
                  </Col>
                </>
              ) : null}
              <Col span={24}>
                <Row>
                  <Col lg={5} xs={24} className="label-col">
                    <label>Send As:</label>
                  </Col>
                  <Col lg={19} xs={24}>
                    {" "}
                    <Form.Item
                      name="sender"
                      className="sender-as"
                      rules={[{ required: true, message: "Enter the sender" }]}
                    >
                      <Select_ name options={options} defaultValue="Myself" />
                    </Form.Item>{" "}
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row gutter={[0, 20]}>
                  <Col lg={5} xs={24} className="label-col">
                    <label>Send To:</label>
                  </Col>
                  <Col lg={9} xs={24}>
                    <Form.Item name="sendTo">
                      <Radio.Group
                        onChange={onChange}
                        value={sendToType}
                        optionType="button"
                        buttonStyle="solid"
                        defaultValue="all"
                        style={{ paddingTop: "5px" }}
                      >
                        <Radio value="all">All</Radio>
                        <Radio value="user">User</Radio>
                        <Radio value="role">Role</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  {sendToType !== "all" && (
                    <Col lg={10} xs={24}>
                      <Form.Item
                        name="recep"
                        className="sender-to"
                        rules={[{ required: true, message: "Please Select" }]}
                        defaultValue="All"
                      >
                        <Select_
                          name
                          options={sentToWhom}
                          defaultValue={"Select here"}
                          allowClear={true}
                          placeholder={`Select ${sendToType}`}
                        />
                      </Form.Item>
                    </Col>
                  )}
                </Row>
              </Col>
              {getUserPermissions("notify-page-send-button-action") && (
                <Col span={24} className="button-col">
                  <Form.Item className="button">
                    <Button
                      htmlType="submit"
                      title={isTask == true ? "Send Task" : "Send Message"}
                    />
                  </Form.Item>
                </Col>
              )}
            </Row>
          </Form>
        </div>
      )}
    </Wrapper>
  );
};

export default NotifyPage;
